import { ColumnDef } from "@tanstack/react-table";
import { SidebarBadge } from "@/referrals/common/sidebar-badge";
import {
  REFERRAL_FIELD,
  REFERRAL_FIELD_TO_SORTER,
} from "@/referrals/constants";
import { IReferral, ReferralStatus } from "@/referrals/referral";

const StatusCol = (): ColumnDef<IReferral> => ({
  header: "Status",
  accessorKey: "status",
  size: 120,
  minSize: 120,
  sortingFn: (a, b) =>
    REFERRAL_FIELD_TO_SORTER[REFERRAL_FIELD.status](a.original, b.original),
  cell: ({ getValue }) => (
    <SidebarBadge status={getValue() as ReferralStatus} />
  ),
});

export default StatusCol;
